import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService, DentalReferralFormReviewNote } from '../../../app.service';
import { AlertService } from '../../../common/alert.service';

@Component({
  selector: 'app-common-note',
  templateUrl: './common-note.component.html',
  styleUrls: ['./common-note.component.scss']
})
export class CommonNoteComponent implements OnInit {

  @Input()
  public note: DentalReferralFormReviewNote;

  @Output()
  OnNoteSave = new EventEmitter<DentalReferralFormReviewNote>();

  @Output()
  OnNoteDelete = new EventEmitter<DentalReferralFormReviewNote>();

  @Input()
  public shrinkNotes: boolean = true;

  @Input()
  public readOnly: boolean = false;

  constructor(
    private service: AppService,
    private alert: AlertService,
  ) { }

  ngOnInit(): void {
  }

  public saveNote(noteToSave: DentalReferralFormReviewNote) {
    this.OnNoteSave.emit(noteToSave);
  }

  public deleteNote(noteToDelete: DentalReferralFormReviewNote) {
    if (window.confirm('Are you sure you want to delete this note?')) {
      this.OnNoteDelete.emit(noteToDelete);
    }
  }

}
